import { Injectable } from '@angular/core'
import * as moment from 'moment-timezone'

@Injectable()
export class TimeService {
   dateFormat: string

   constructor() {
      if (!this.dateFormat) this.dateFormat = 'DD/MM/YYYY' // 'YYYY-MM-DD[T]HH:mm:ss.sssZ'
   }

   getDate(date?: any) {
      if (!date) date = new Date() // date or today

      let eMoment = moment.utc(date)

      if (eMoment instanceof moment) {
         return eMoment
      }

      return false
   }

   getMomentDate(date?: any) {
      return date instanceof moment ? date : this.getDate(date)
   }

   getDateFormatted(date?: any, dateFormat?: string) {
      const eMoment = this.getMomentDate(date)

      if (eMoment instanceof moment) {
         return eMoment['format'](dateFormat || this.dateFormat)
      }

      return ''
   }

   getLocalizedDateFormatted(date?: any, dateFormat?: string) {
      return moment(date).local().format(dateFormat)
   }

   getDateIso(date?: any) {
      const eMoment = this.getMomentDate(date)

      if (eMoment instanceof moment) {
         return eMoment['toISOString'](true) // true for locale time
      }

      return ''
   }

   getTime(date: any) {
      const time = this.getDateFormatted(date, 'HH:mm')

      if (time) {
         return time
      }

      return '00:00'
   }

   setTime(date: any, time: string) {
      //HH:mm

      const eMoment = this.getMomentDate(date)
      const timeSplit = time.split(':')

      if (eMoment instanceof moment && timeSplit.length > 1) {
         eMoment['set']({ h: timeSplit[0], m: timeSplit[1] })

         return eMoment
      }

      return false
   }

   removeTime(date: any, minutes: number) {
      const eMoment = this.getMomentDate(date)

      if (eMoment instanceof moment) {
         eMoment['subtract'](minutes, 'minutes').toDate()

         return eMoment
      }

      return false
   }

   isDateBefore(date: any, dateLimit: any) {
      const eMoment = this.getMomentDate(date)
      const eMomentLimit = this.getMomentDate(dateLimit)

      if (eMoment instanceof moment && eMomentLimit instanceof moment) {
         return eMoment['isBefore'](eMomentLimit)
      }

      return undefined
   }
}
